var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar",style:(_vm.$store.state.theme.themeBackgroundPage == 1
      ? `background: var(--primary-color);`
      : `background: transparent;`)},[(!_vm.isShowing)?_c('div',[_c('img',{staticClass:"logo-img",attrs:{"src":_vm.$store.state.domain + _vm.$store.state.theme.themeLogoLine}})]):_c('div',[_c('img',{staticClass:"logo-img",attrs:{"src":_vm.$store.state.domain + _vm.$store.state.theme.themeLogoLine},on:{"click":_vm.toProfile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }